import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseCrudModalComponent } from 'projects/ProjetoBaseAngular/app/base-crud-modal.component';
import { TypesService } from 'projects/admin/src/domain/services';
import { MetaMsgTemplateModel } from '../../../domain/models';
import { MetaMsgTemplateCategory, MetaMsgTemplateStatus } from '../../../domain/types';
import { MetaMsgTemplateService } from '../../../domain/services/meta-msg-template.service';
import { ConfigService } from 'projects/ProjetoBaseAngular/domain/services';
import { ConfigChatbotConsts } from 'projects/admin/src/domain/consts';

@Component({
  selector: 'app-meta-msg-template-modal',
  templateUrl: './msg-template-modal.component.html'
})
export class MetaMsgTemplateModalComponent extends BaseCrudModalComponent<MetaMsgTemplateModel> implements OnInit {
  @ViewChild('modal') modal: ModalDirective;

  isTemplateConfirmacaoPresenca = false;

  constructor(
    injector: Injector,
    readonly service: MetaMsgTemplateService,
    readonly typesService: TypesService,
    readonly configService: ConfigService
  ) {
    super(injector, service);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected initializeForm(model: MetaMsgTemplateModel) {
    this.carregarTemplateConfirmacaoPresenca(model.metaTemplateId);

    this.form = this.formBuilder.group({
      id: model.id,
      dataInclusao: [this.fromJsonDate(model.dataInclusao), Validators.required],
      dataAlteracao: [this.fromJsonDate(model.dataAlteracao)],
      registroAtivo: [model.registroAtivo],
      whatsAppBusinessAccountId: [model.whatsAppBusinessAccountId, Validators.maxLength(100)],
      metaTemplateId: [model.metaTemplateId, Validators.maxLength(100)],
      name: [model.name, [Validators.required, Validators.maxLength(512), Validators.pattern(/^[a-z0-9_]+$/)]],
      language: [model.language, [Validators.required, Validators.maxLength(10)]],
      categoria: [model.categoria, Validators.required],
      status: [model.status, Validators.required],
      rejectionReason: [model.rejectionReason, Validators.maxLength(500)],
      qualityScore: [model.qualityScore, Validators.maxLength(50)],
      submittedAt: [this.fromJsonDate(model.submittedAt)],
      metaUpdatedAt: [this.fromJsonDate(model.metaUpdatedAt)]
    });

    this.form.get('language').disable();
    this.form.get('whatsAppBusinessAccountId').disable();
    this.form.get('metaTemplateId').disable();
    this.form.get('status').disable();
    this.form.get('qualityScore').disable();
    this.form.get('rejectionReason').disable();
    this.form.get('submittedAt').disable();
    this.form.get('metaUpdatedAt').disable();
  }

  protected newModel(): MetaMsgTemplateModel {
    const model = new MetaMsgTemplateModel();
    model.whatsAppBusinessAccountId = "";
    model.metaTemplateId = "";
    model.name = "";
    model.language = "pt_BR";
    model.categoria = MetaMsgTemplateCategory.Utility;
    model.status = MetaMsgTemplateStatus.Draft;
    model.rejectionReason = "";
    model.qualityScore = "";
    model.submittedAt = null;
    model.metaUpdatedAt = null;

    return model;
  }

  async save(autoSave: boolean = false) {
    if (!await this.validateToSave(autoSave)) {
      return;
    }

    this.isBusy = true;
    let model: MetaMsgTemplateModel = Object.assign({}, this.form.getRawValue());
    model = await this.beforeSave(model);
    if (this.newItem) {
      await this.create(model, autoSave);
    } else {
      await this.edit(model, autoSave);
    }
  }

  autoSave() {
    return this.save(true);
  }

  private carregarTemplateConfirmacaoPresenca(metaTemplateId: string) {
    this.isTemplateConfirmacaoPresenca = false;

    if (!metaTemplateId) {
      return;
    }

    this.configService.getConfigByGrupoChave('ChatBot', ConfigChatbotConsts.TemplatePadraoConfirmacaoPresenca)
      .subscribe(
        config => this.isTemplateConfirmacaoPresenca = (config?.valor || '').trim() === metaTemplateId.trim(),
        () => this.isTemplateConfirmacaoPresenca = false
      );
  }
}
